import state from './moduleEnterpriseMapVesselTargetState.js'
import mutations from './moduleEnterpriseMapVesselTargetMutations.js'
import actions from './moduleEnterpriseMapVesselTargetActions.js'
import getters from './moduleEnterpriseMapVesselTargetGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
